<template>
  <div class="flex flex-1 relative rounded overflow-hidden">
    <div class="absolute w-full h-full z-0">
      <img
        alt="item"
        class="relative w-full h-full left-0 top-0 object-cover"
        src="/src/assets/images/vip_img_2.jpg"
      />
    </div>
    <div class="absolute w-full h-full z-10 vip-gradient"></div>
    <div
      class="flex flex-col z-20 w-full pt-[15px] pl-[12px] pb-[12px] pr-[15px]"
    >
      <div class="flex flex-1 flex-row gap-[8px]">
        <div
          class="flex flex-none justify-center h-[32px] w-[32px] items-center bg-secondary-500 rounded-full"
        >
          <span class="material-symbols-rounded text-xl text-secondary-900"
            >shopping_basket</span
          >
        </div>
        <div class="flex flex-col">
          <p class="text-lg font-bold text-secondary-500">איסוף המוצרים</p>
          <p class="text-base font-regular text-white">
            מנהל התחנה יאסוף בשבילכם את ההזמנה.
          </p>
        </div>
      </div>
      <div class="flex flex-row items-center justify-end gap-[12px]">
        <p class="text-base text-white font-bold">20.00₪</p>
        <button-cta
          :disabled="isInCart(product)"
          :small="true"
          @click="handleAddToCart"
        >
          להוסיף להזמנה
        </button-cta>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "vip-banner-collecting",
  data() {
    return {
      product: {
        id: 9919234,
        name: "איסוף המוצרים",
        type: "collecting",
        price: 45,
      },
    };
  },
  methods: {
    ...mapActions({
      addToCart: "cart/addToCart",
      showToast: "orderToast/showToast",
    }),
    handleAddToCart() {
      this.addToCart(this.product);
      this.showToast({
        message: this.product.name,
        type: "add",
      });
    },
  },
  computed: {
    ...mapGetters({
      isInCart: "cart/isInCart",
    }),
  },
};
</script>

<style scoped>
.vip-gradient {
  background: linear-gradient(
    270deg,
    #3f238b 65.63%,
    #3f238b91 100%,
    rgba(26, 6, 79, 0.55) 0%
  );
}
</style>